export default __webpack_public_path__ + "static/media/lavirginia_cafe.30696b51.jpg";